export default {
  adminNotificationList: [],
  busNotificationList: [],
  parentUpdateHistoryList: [],
  parentNotificationList: [],
  currentParentHistoryFilter: null,
  currentParentHistorySort: null,
  currentParentHistoryPage: null,
  currentParentNotificationFilter: null,
  currentParentNotificationSort: null,
  currentParentNotificationPage: null,
  currentBusNotificationFilter: null,
  currentBusNotificationSort: null,
  currentBusNotificationPage: null,
  currentAdminNotificationPage: null,
  cancelList: [],
  currentCancelFilter: null,
  currentCancelSort: null,
  currentCancelPage: null,
  authorizedPersonFilter: null,
  authorizedPersonSort: null,
  authorizedPersonPage: null,
}
